import { Capacitor } from '@capacitor/core';

/**
 * Whether this is the app on a phone rather than the site in a browser.
 *
 * The same code runs in both, and two things genuinely differ. The app is served from
 * `capacitor://localhost` (iOS) or `https://localhost` (Android), so anything derived from
 * `location.origin` is wrong there. And the app cannot complete a Home sign-in — see
 * `homeSignInAvailable` for why.
 */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** `ios`, `android`, or `web`. Stage 3 shows Apple Health only on the first. */
export function platform(): string {
  return Capacitor.getPlatform();
}

/**
 * Whether the Home sign-in door can actually open here.
 *
 * In a browser: yes. In the app: no, and not for a reason we can fix on this side.
 *
 * The ceremony ends by redirecting to a registered `redirect_uri`, and the Home refuses to
 * register anything that is not https, or http on loopback (`validateRedirectUri` in the Home's
 * oidc-registry: a custom scheme comes back `redirect_uri_insecure`). So `heartcoach://auth` — the
 * usual way an app catches a redirect — cannot be registered at all.
 *
 * The one shape that would pass is a Universal Link on `heartcoach.faithnet.io`, which needs the
 * Associated Domains entitlement, which needs a PAID Apple Developer account. Until one of those
 * two things changes, the app signs in with an emailed link or a dev session, and it says so
 * rather than showing a button that leads somewhere the patient cannot come back from.
 */
export function homeSignInAvailable(): boolean {
  return !isNative();
}
